import Product from "./product";
import player from "./player";

class ProductTracks extends Product {
	init() {
		super.init();
		const jsProduct = this.jsProduct;
		const productId = this.id;
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsPlayTrack`)
			?.forEach((jsPlayTrack) => {
				const handler = () => {
					let track = jsPlayTrack.dataset.file + "";
					// // костыль
					// if (jsPlayTrack.classList.contains("jsPlayMainTrack")) {
					// 	const isMainTrack =
					// 		jsProduct.dataset.file ===
					// 		(<any>window).globalState.activeTrack;

					// 	if (!isMainTrack && !player.dom.audio.paused) {
					// 		this.pause();
					// 		return;
					// 	}
					// }
					// // END
					if (!jsPlayTrack.dataset.file) {
						track =
							(<any>window).globalState.activeTrack ||
							jsProduct.dataset.file + "";
						const isSameProduct =
							(<any>window).globalState.activeProductId ===
							productId;
						if (!isSameProduct) {
							track = jsProduct.dataset.file + "";
						}
					}
					this.playToggle(productId, track);
				};

				this.addEventListener({
					node: jsPlayTrack,
					event: "click",
					handler: handler,
				});
			});

		return false;
	}
	closeProduct() {
		player.dom.audio.pause();
		super.closeProduct();
	}
	playToggle(productId: number, track: string) {
		if ((<any>window).playToggleTimer === true) return false;
		console.log("playToggle", productId, (<any>window).playToggleTimer);
		(<any>window).playToggleTimer = true;
		setTimeout(() => {
			(<any>window).playToggleTimer = false;
		}, 150);
		const prodState = this.state;
		const isSameProduct =
			(<any>window).globalState.activeProductId === productId;
		const isSameTrack = (<any>window).globalState.activeTrack === track;
		if (
			isSameProduct &&
			isSameTrack &&
			(<any>window).player.dom.audio.paused === false
		) {
			this.pause();

			return false;
		}
		if (!isSameProduct) {
			console.log("playToggle !isSameProduct");
			this.play(productId, track);
			return false;
		}
		if (prodState.isPlaying && isSameTrack) {
			console.log("playToggle pause");

			this.pause();
		} else {
			this.play(productId, track);
		}
	}
	play(productId: number, track: string) {
		this.state.isTrackLoading = false;

		(<any>window).globalState.activeTrack = track;
		(<any>window).globalState.activeProductId = productId;

		if (player.props.productId !== productId) {
			player.setProps({
				productId: productId,
				onChange: () => {
					// console.log("this.id", this.id);
				},
				onCanplay: () => {
					this.onCanplay();
				},
				onPlay: () => {
					this.onPlay();
				},
				onPause: () => {
					this.onPause();
				},
				onEnded: () => {
					this.next();
				},
				onWaiting: () => {
					this.onWaiting();
				},
				next: () => {
					this.next();
				},
			});
			const jsProgressbar =
				this.jsProduct?.querySelector<HTMLElement>(`.jsProgressbar`)!;
			player.setControlsNodes(jsProgressbar);
		}
		if (player.props.productId && player.props.productId !== productId) {
			(() => {
				const prevProd = (<any>window).productsMain.products[
					player.props.productId
				];
				// console.log("prevProd", prevProd);
				prevProd.state.isTrackLoading = false;
				prevProd.state.isPlaying = false;
				prevProd.render();
			})();
		}

		player.play(track);
	}
	pause() {
		player.dom.audio.pause();
		// Object.keys(main.state.products).forEach((id: any) => {
		// 	main.state.products[id].isPlaying = false;
		// 	main.state.products[id].isTrackLoading = false;
		// });
	}
	onCanplay() {
		this.state.isTrackLoading = false;
		this.onChange();
	}
	onPlay() {
		this.state.isTrackLoading = false;
		this.state.isPlaying = true;
		if (!this.state.isOpen) {
			this.openProduct();
		}
		this.onChange();
	}
	onPause() {
		this.state.isTrackLoading = false;
		this.state.isPlaying = false;
		this.onChange();
	}

	onWaiting() {
		this.state.isTrackLoading = true;
		this.onChange();
	}
	prev() {
		const jsPlayTrack = this.jsProduct?.querySelector<HTMLElement>(
			`.jsPlayList .jsPlayTrack[data-file="${
				(<any>window).globalState.activeTrack
			}"]`
		);
		if (jsPlayTrack && jsPlayTrack.previousElementSibling) {
			const node = <HTMLElement>jsPlayTrack.previousElementSibling;
			node.click();
		}
	}
	next() {
		const jsPlayTrack = this.jsProduct?.querySelector<HTMLElement>(
			`.jsPlayList .jsPlayTrack[data-file="${
				(<any>window).globalState.activeTrack
			}"]`
		);
		// console.log("next2" , jsPlayTrack , `.jsPlayList .jsPlayTrack[data-file="${(<any>window).globalState.activeTrack}"`)
		if (jsPlayTrack && jsPlayTrack.nextElementSibling) {
			const node = <HTMLElement>jsPlayTrack.nextElementSibling;
			node.click();
		} else {
			const jsProduct = document.querySelector<HTMLElement>(
				`.jsProduct[data-id="${
					(<any>window).globalState.activeProductId
				}"]`
			);
			const firstListTrack = jsProduct?.querySelector<HTMLElement>(
				`.jsPlayList .jsPlayTrack`
			);
			if (firstListTrack) {
				firstListTrack.click();
			} else {
				const refreshIntervalId = setInterval(() => {
					if (this.state.contentUploaded) {
						const firstListTrack =
							jsProduct?.querySelector<HTMLElement>(
								`.jsPlayList .jsPlayTrack`
							);
						clearInterval(refreshIntervalId);
						firstListTrack?.click();
					}
				}, 1000);
			}
		}
	}
	onChange() {
		super.onChange();
	}
	render() {
		super.render();
		// console.log("ProductTracks render")
		const jsPlayTracks = this.jsProduct.querySelectorAll<HTMLElement>(
			`.jsPlayList .jsPlayTrack`
		);

		jsPlayTracks.forEach((jsPlayTrack) => {
			const item = jsPlayTrack.querySelector<HTMLElement>(
				`.jsControlViewPlay_PlayList`
			)!;
			item.classList.remove(`isPlaying`);
			item.classList.remove(`isTrackLoading`);
			if (
				jsPlayTrack.dataset.file ===
				(<any>window).globalState.activeTrack
			) {
				super.setControlPlayClasses(item, this.state);
			}
		});
	}
}

export default ProductTracks;
